export default __webpack_public_path__ + "static/media/download-file.c610c2cf.svg";